import React from 'react';

import { createClassName } from 'utils/createClassName';

import './homeCardLayoutStyles.scss';

type Props = {
  theme: 'dark' | 'light';
  size: 'mini' | 'auto';
};

export const HomeCardLayoutComponent: React.FC<Props> = (props) => {
  const { children, theme, size } = props;

  const createHomePageLayoutClassName = createClassName('homeCardLayout');

  const wrapperClassName = createHomePageLayoutClassName('wrapper', {
    theme,
    size,
  });

  return <div className={wrapperClassName}>{children}</div>;
};
